import { render, staticRenderFns } from "./beneficiaries-list.vue?vue&type=template&id=4f7a504e&scoped=true&"
import script from "./beneficiaries-list.vue?vue&type=script&lang=js&"
export * from "./beneficiaries-list.vue?vue&type=script&lang=js&"
import style0 from "./beneficiaries-list.vue?vue&type=style&index=0&id=4f7a504e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a504e",
  null
  
)

export default component.exports